import { query, serviceQueries } from '@estee/elc-service-bus';

import { ISDProduct } from '~api/ProductAPI/IProductAPIs';

interface IProductDataOptionsFilters {
    tags?: {
        ids?: string[];
        keys?: string[];
        values?: string[];
    };
    skus?: {
        inventoryStatus?: string[];
        skuIds?: string[];
        isDefaultSku?: boolean;
        shades?: { name: string[] };
    };
    productIds?: string[];
}

export const fetchDonationsByCustomQuery = (filter: IProductDataOptionsFilters) =>
    query(serviceQueries.GET_PRODUCT_DATA, {
        filterBy: filter
    }) as Promise<ISDProduct[]>;
